/** Goal-type labels + extra vitals strings for regional aiDashboard locales. */

const mkGoals = (
  understand,
  manage,
  lifeStage,
  mindStress,
  getFit,
  eatBetter,
  fitnessActivity
) => ({
  UNDERSTAND_MY_HEALTH: understand,
  MANAGE_A_CONDITION: manage,
  LIFE_STAGE_AND_FAMILY: lifeStage,
  MIND_STRESS_AND_SLEEP: mindStress,
  GET_FIT_AND_MOVE_MORE: getFit,
  EAT_AND_NOURISH_BETTER: eatBetter,
  FITNESS_AND_ACTIVITY: fitnessActivity,
});

const mkVitals = (respRate, breathsPerMin, hrv, milliseconds, stress, stressLevel) => ({
  respRate,
  breathsPerMin,
  hrv,
  milliseconds,
  stress,
  stressLevel,
});

export const AI_DASHBOARD_GOAL_AND_VITALS = {
  pa: {
    ...mkVitals(
      "ਸਾਹ ਦੀ ਦਰ",
      "ਸਾਹ/ਮਿੰਟ",
      "ਹਿਰਦੇ ਦੀ ਦਰ ਵਿਭਿੰਨਤਾ",
      "ਮਿ.ਸੇ.",
      "ਤਣਾਅ",
      "ਪੱਧਰ"
    ),
    goalTypes: mkGoals(
      "ਆਪਣੀ ਸਿਹਤ ਸਮਝੋ",
      "ਹਾਲਤ ਦਾ ਪ੍ਰਬੰਧਨ",
      "ਜੀਵਨ ਪੜਾਅ ਅਤੇ ਪਰਿਵਾਰ",
      "ਮਨ, ਤਣਾਅ ਅਤੇ ਨੀਂਦ",
      "ਫਿੱਟ ਰਹੋ ਅਤੇ ਹੋਰ ਹਿਲੋ",
      "ਬਿਹਤਰ ਖਾਓ ਅਤੇ ਪੋਸ਼ਣ ਲਓ",
      "ਫਿਟਨੈਸ ਅਤੇ ਗਤੀਵਿਧੀ"
    ),
    filterByGoal: "ਲਕਸ਼ ਅਨੁਸਾਰ ਫਿਲਟਰ ਕਰੋ",
    allGoals: "ਸਾਰੇ ਲਕਸ਼",
    clearGoals: "ਸਾਫ਼ ਕਰੋ",
    goalsSelected: "ਲਕਸ਼ ਚੁਣੇ",
    filterByLanguage: "ਭਾਸ਼ਾ",
    videoFilters: "ਵੀਡੀਓ ਫਿਲਟਰ",
    languageEnglish: "ਅੰਗਰੇਜ਼ੀ",
    languageHindi: "ਹਿੰਦੀ",
  },
  te: {
    ...mkVitals(
      "శ్వాస రేటు",
      "శ్వాసలు/నిమి",
      "గుండె చప్పుడు వైవిధ్యం",
      "మి.సె.",
      "ఒత్తిడి",
      "స్థాయి"
    ),
    goalTypes: mkGoals(
      "నా ఆరోగ్యాన్ని అర్థం చేసుకోండి",
      "పరిస్థితిని నిర్వహించండి",
      "జీవిత దశ & కుటుంబం",
      "మనసు, ఒత్తిడి & నిద్ర",
      "ఫిట్‌గా ఉండి మరింత కదలండి",
      "మంచి ఆహారం & పోషణ",
      "ఫిట్నెస్ మరియు కార్యాచరణ"
    ),
    filterByGoal: "లక్ష్యం ప్రకారం ఫిల్టర్ చేయండి",
    allGoals: "అన్ని లక్ష్యాలు",
    clearGoals: "క్లియర్",
    goalsSelected: "లక్ష్యాలు ఎంచుకున్నారు",
    filterByLanguage: "భాష",
    videoFilters: "వీడియో ఫిల్టర్లు",
    languageEnglish: "ఇంగ్లీష్",
    languageHindi: "హిందీ",
  },
  ta: {
    ...mkVitals(
      "சுவாச விகிதம்",
      "சுவாசம்/நிமி",
      "இதயத் துடிப்பு மாறுபாடு",
      "மி.வி.",
      "மன அழுத்தம்",
      "நிலை"
    ),
    goalTypes: mkGoals(
      "என் ஆரோக்கியத்தைப் புரிந்துகொள்",
      "நிலைமையை நிர்வகி",
      "வாழ்க்கை நிலை & குடும்பம்",
      "மனம், மன அழுத்தம் & தூக்கம்",
      "ஃபிட்டாக இருந்து அதிகம் அசை",
      "சிறந்த உணவு & ஊட்டச்சத்து",
      "உடற்பயிற்சி மற்றும் செயல்பாடு"
    ),
    filterByGoal: "இலக்கு அடிப்படையில் வடிகட்டு",
    allGoals: "அனைத்து இலக்குகள்",
    clearGoals: "அழி",
    goalsSelected: "இலக்குகள் தேர்ந்தெடுக்கப்பட்டன",
    filterByLanguage: "மொழி",
    videoFilters: "வீடியோ வடிகட்டிகள்",
    languageEnglish: "ஆங்கிலம்",
    languageHindi: "ஹிந்தி",
  },
  mr: {
    ...mkVitals(
      "श्वसन दर",
      "श्वास/मिनिट",
      "हृदय गती विविधता",
      "मि.से.",
      "तणाव",
      "पातळी"
    ),
    goalTypes: mkGoals(
      "माझे आरोग्य समजा",
      "स्थिती व्यवस्थापित करा",
      "जीवन टप्पा आणि कुटुंब",
      "मन, तणाव आणि झोप",
      "फिट राहा आणि अधिक हलवा",
      "चांगले खा आणि पोषण घ्या",
      "फिटनेस आणि क्रियाकलाप"
    ),
    filterByGoal: "ध्येयानुसार फिल्टर करा",
    allGoals: "सर्व ध्येये",
    clearGoals: "साफ करा",
    goalsSelected: "ध्येये निवडली",
    filterByLanguage: "भाषा",
    videoFilters: "व्हिडिओ फिल्टर",
    languageEnglish: "इंग्रजी",
    languageHindi: "हिंदी",
  },
  bn: {
    ...mkVitals(
      "শ্বাসের হার",
      "শ্বাস/মিনিট",
      "হৃদস্পন্দনের পরিবর্তন",
      "মি.সে.",
      "চাপ",
      "স্তর"
    ),
    goalTypes: mkGoals(
      "আমার স্বাস্থ্য বুঝুন",
      "অবস্থা পরিচালনা করুন",
      "জীবনের পর্যায় ও পরিবার",
      "মন, চাপ ও ঘুম",
      "ফিট থাকুন ও বেশি চলাফেরা করুন",
      "ভালো খান ও পুষ্টি নিন",
      "ফিটনেস ও কার্যকলাপ"
    ),
    filterByGoal: "লক্ষ্য অনুযায়ী ফিল্টার",
    allGoals: "সব লক্ষ্য",
    clearGoals: "মুছুন",
    goalsSelected: "লক্ষ্য নির্বাচিত",
    filterByLanguage: "ভাষা",
    videoFilters: "ভিডিও ফিল্টার",
    languageEnglish: "ইংরেজি",
    languageHindi: "হিন্দি",
  },
  kn: {
    ...mkVitals(
      "ಉಸಿರಾಟದ ದರ",
      "ಉಸಿರುಗಳು/ನಿಮಿ",
      "ಹೃದಯ ಬಿಡುಗಡೆಯ ವೈವಿಧ್ಯ",
      "ಮಿ.ಸೆ.",
      "ಒತ್ತಡ",
      "ಮಟ್ಟ"
    ),
    goalTypes: mkGoals(
      "ನನ್ನ ಆರೋಗ್ಯವನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಿ",
      "ಸ್ಥಿತಿಯನ್ನು ನಿರ್ವಹಿಸಿ",
      "ಜೀವನ ಹಂತ ಮತ್ತು ಕುಟುಂಬ",
      "ಮನಸ್ಸು, ಒತ್ತಡ ಮತ್ತು ನಿದ್ರೆ",
      "ಫಿಟ್ ಆಗಿರಿ ಮತ್ತು ಹೆಚ್ಚು ಚಲಿಸಿ",
      "ಉತ್ತಮ ಆಹಾರ ಮತ್ತು ಪೋಷಣೆ",
      "ಫಿಟ್ನೆಸ್ ಮತ್ತು ಚಟುವಟಿಕೆ"
    ),
    filterByGoal: "ಗುರಿಯ ಪ್ರಕಾರ ಫಿಲ್ಟರ್ ಮಾಡಿ",
    allGoals: "ಎಲ್ಲಾ ಗುರಿಗಳು",
    clearGoals: "ತೆರವುಗೊಳಿಸಿ",
    goalsSelected: "ಗುರಿಗಳು ಆಯ್ಕೆಯಾಗಿವೆ",
    filterByLanguage: "ಭಾಷೆ",
    videoFilters: "ವೀಡಿಯೊ ಫಿಲ್ಟರ್‌ಗಳು",
    languageEnglish: "ಇಂಗ್ಲೀಷ್",
    languageHindi: "ಹಿಂದಿ",
  },
};

export const applyAiDashboardGoalAndVitalsLocales = (translations) => {
  const enGoals = translations.en?.aiDashboard?.goalTypes ?? {};

  Object.entries(AI_DASHBOARD_GOAL_AND_VITALS).forEach(([lang, block]) => {
    if (!translations[lang]?.aiDashboard) return;
    const { goalTypes, ...rest } = block;
    translations[lang].aiDashboard = {
      ...translations[lang].aiDashboard,
      ...rest,
      goalTypes: {
        ...enGoals,
        ...goalTypes,
      },
    };
  });
};
